import { render, staticRenderFns } from "./EditVisioDocument.vue?vue&type=template&id=6bec3d5e&"
import script from "./EditVisioDocument.vue?vue&type=script&lang=js&"
export * from "./EditVisioDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports